<template>
    <div id="sign-in-form-1">
        <form @submit.prevent class="form-body">
            <div class="login-title">
                <p class="title is-3">{{ $t("Sign In") }}</p>
                <p style="margin-top: 7px">
                    {{ $t("New user?") }}
                    <router-link :to="{ name: 'sign-up' }">
                        <span
                            class="has-text-primary"
                            style="cursor: pointer; font-size: 20px"
                            >{{ $t("Create an account") }}</span
                        >
                    </router-link>
                </p>
            </div>
            <div
                class="level"
                style="margin-bottom: 0; display: flex; height: 450px"
            >
                <div
                    class="level-item"
                    style="flex-direction: column; width: 100%"
                >
                    <div class="input-container">
                        <label>{{ $t("Password") }}</label>
                        <custom-input
                            :placeholder="$t('Password')"
                            :capitalize="false"
                            :required="true"
                            type="password"
                            @value="validatePassword($event)"
                            ref="password"
                        ></custom-input>
                        <p
                            v-if="error"
                            class="error"
                            style="margin-top: 30px; text-align: center"
                        >
                            {{ $t(error) }}
                        </p>
                    </div>
                    <div style="display: flex; justify-content: center">
                        <Loading v-if="loading" />
                    </div>
                    <div
                        v-if="!loading"
                        style="
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                        "
                    >
                        <button
                            type="button"
                            class="auth-button"
                            @click="$router.push({ name: 'sign-in-email' })"
                        >
                            {{ $t("Back") }}
                        </button>
                        <button
                            type="submit"
                            :class="[
                                'auth-button primary-btn',
                                { 'is-loading': loading },
                            ]"
                            :disabled="loading"
                            @click="signIn"
                        >
                            {{ $t("Sign in") }}
                        </button>
                    </div>
                    <p
                        class="form-gray"
                        style="
                            width: 100%;
                            margin-top: 15px;
                            text-align: right;
                            cursor: pointer;
                        "
                    >
                        <router-link :to="{ name: 'forget-password' }">{{
                            $t("Forgot your password?")
                        }}</router-link>
                    </p>
                </div>
            </div>
            <div
                class="form-footer form-gray"
                style="height: 40px; padding: 15px 0"
            >
                <p>
                    {{ $t("Protected by ALKOON and subject to our") }}
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/privacy_and_security.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Privacy Policy") }}
                        </span>
                    </a>
                    <span>{{ $t(" and ") }}</span>
                    <a
                        target="_blank"
                        href="https://alkoonshipping.com/terms_and_conditions.html"
                    >
                        <span class="has-text-primary" style="cursor: pointer">
                            {{ $t("Terms of Service.") }}
                        </span>
                    </a>
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import CustomInput from "@/components/CustomInput.vue";
import Loading from "@/components/Loading";

export default {
    components: {
        Loading,
        "custom-input": CustomInput,
    },
    data() {
        return {
            user: {
                username: "",
                password: "",
            },
            loading: false,
            error: false,
        };
    },
    watch: {
        "user.password"(val) {
            this.error = false;
        },
    },
    methods: {
        signIn() {
            this.user.username = localStorage.getItem("email");
            if (!this.user.username)
                return this.$router.push({
                    name: "sign-in-email",
                });
            if (this.user.username === "" || this.user.password === "") {
                return (this.error = "Please type your Password correctly");
            }
            this.loading = true;
            if (this.user.username != "" && this.user.password != "") {
                this.$store
                    .dispatch("login", this.user)
                    .then((r) => {
                        location.reload();
                        this.loading = false;
                        // if (this.$store.state.user.verified) {
                        localStorage.setItem("email", null);
                        this.$router.push("/my-shipment");
                        // } else {
                        //     this.$router.push({
                        //         name: "verify-mobile",
                        //     });
                        // }
                    })
                    .catch((e) => {
                        this.loading = false;
                        this.error = "Please type a valid password";
                    });
            }
        },
        validatePassword(n) {
            this.user.password = n;
            if (this.user.password.length > 3) {
                this.$refs.password.validationError = false;
                this.$refs.password.messageError = "";
                return;
            } else {
                this.$refs.password.validationError = true;
                this.$refs.password.messageError = this.$t(
                    "Please add a valid password"
                );
            }
        },
    },
    mounted() {
        if (!localStorage.getItem("email")) {
            this.$router.push({
                name: "sign-in-email",
            });
        }
        document.querySelectorAll(".input").forEach((input) => {
            input.setAttribute("style", "border-radius: 10px;");
        });
        document.querySelector(".mdi-eye").style.color = "#000";
    },
};
</script>

<style lang="scss" scoped>
$error: #eb6174;
label {
    font-size: 14px;
    color: #000;
}
.login-title {
    padding: 5px 0 0;

    p {
        // color: white;
        text-align: left;
        margin: 0;

        &:first-of-type {
            font-size: 36px;
        }
    }
}

.error {
    color: $error;
}

.help {
    color: $error !important;
}

#sign-in-form-1 {
    // margin-top: 50px;
    // width: 500px !important;
    // width: 100%;
    height: 100%;
    z-index: 1;

    .form-body {
        border-radius: 5px;
        text-align: center;
        margin: 10px 0;
        background-color: white;
        min-width: 500px;
        padding: 40px 50px;
        width: 500px;
        // height: 500px;
        display: inline-block;

        @media screen and (max-width: 600px) {
            padding: 40px 10px;
            min-width: 100%;
            width: 100%;
        }

        ::-webkit-input-placeholder {
            /* Edge */
            font-size: 14px;
        }

        :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            font-size: 14px;
        }

        ::placeholder {
            font-size: 14px;
        }

        .input-container {
            width: 100%;
            // min-width: 350px;
            margin-bottom: 60px;
        }

        .field:not(:last-child) {
            height: 75px;
        }

        .help {
            color: $error !important;
        }

        .label {
            text-align: left;
        }

        .control {
            width: 350px;
            display: inline-block;
        }

        .form-gray {
            color: #9b9b9b;
            font-size: 14px;
        }
    }
}
</style>
